module.exports = __webpack_public_path__ + "2dedba83c1fbdd83a6f28ea53371fe7c.svg";